/**
 * @fileoverview GET handler for the "/companies/:company_id/sender_verification/sending_domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { companiesCompanyIdSenderVerificationSendingDomains } from "./constants";
import type { CompaniesCompanyIdSenderVerificationSendingDomainsResult } from "./types";

export const getCompaniesCompanyIdSenderVerificationSendingDomains = reactQueryFetcherAdapter(
  companiesCompanyIdSenderVerificationSendingDomains,
  (signal: AbortSignal, companyId: string): Promise<CompaniesCompanyIdSenderVerificationSendingDomainsResult> => {
    return fetch(`/companies/${companyId}/sender_verification/sending_domains`, "GET", {}, { signal });
  }
);
